const UNIVERSAL = {
  // BASEURL: "https://tapxtestbackend-985701680623.asia-south1.run.app/",
  BASEURL: "https://socialmediabackend-985701680623.asia-south1.run.app/",
  // BASEURL: "https://addaa26d8943.ngrok-free.app/", // Direct URL (causes CORS)
  // BASEURL: "/", // Proxied through React dev server (no CORS)
};
export default UNIVERSAL;
